import { ThemeName } from "@/styles/Theme";

export const ORG_BILDTVAPP = "BILDTVAPP";
export const DEFAULT_BRAND_SETTINGS: BrandSettings = {
  id: "default",
  themeName: ThemeName.default,
  locale: "de_de",
};

export type BrandSettings = {
  id: string;
  locale: string;
  themeName: ThemeName;
  xHandle?: string;
};

export type Organization = BrandSettings & {
  categories?: BrandSettings[];
};

export const organizations: Organization[] = [
  {
    id: "WELT",
    themeName: ThemeName.welt,
    xHandle: "welt",
    categories: [
      {
        id: "icon",
        themeName: ThemeName.icon,
        xHandle: "ICONISTbyicon",
        locale: "de_de",
      },
    ],
    locale: "de_de",
  },
  { id: "BILD", themeName: ThemeName.bild, xHandle: "bild", locale: "de_de" },
  {
    id: "BILD-BOOKS",
    themeName: ThemeName.default,
    locale: "de_de",

    categories: [
      {
        id: "travelbook",
        themeName: ThemeName.bild_travelbook,
        xHandle: "travelbook_de",
        locale: "de_de",
      },
      {
        id: "fitbook",
        themeName: ThemeName.bild_fitbook,
        xHandle: "fitbook_de",
        locale: "de_de",
      },
      {
        id: "stylebook",
        themeName: ThemeName.bild_stylebook,
        xHandle: "stylebook_de",
        locale: "de_de",
      },
      {
        id: "techbook",
        themeName: ThemeName.bild_techbook,
        xHandle: "techbook",
        locale: "de_de",
      },
      {
        id: "myhomebook",
        themeName: ThemeName.bild_myhomebook,
        xHandle: "myhomebook_de",
        locale: "de_de",
      },
    ],
  },
  {
    id: "AUBI",
    themeName: ThemeName.aubi,
    xHandle: "autobild",
    locale: "de_de",
  },
  {
    id: "COBI",
    themeName: ThemeName.cobi,
    xHandle: "COMPUTERBILD",
    locale: "de_de",
  },
  {
    id: "SPOBI",
    themeName: ThemeName.spobi,
    xHandle: "SPORTBILD",
    locale: "de_de",
  },
  { id: "BZ", themeName: ThemeName.bild, xHandle: "bz", locale: "de_de" },
  {
    id: "BRANDSTUDIO",
    themeName: ThemeName.default,
    locale: "de_de",
    categories: [
      {
        id: "bild-brand",
        themeName: ThemeName.bild_brandstory,
        xHandle: "bild",
        locale: "de_de",
      },
      {
        id: "bild-product-advertorial",
        themeName: ThemeName.bild_productstory,
        xHandle: "bild",
        locale: "de_de",
      },
      {
        id: "books-travelbook-brand",
        themeName: ThemeName.bild_travelbook,
        xHandle: "travelbook_de",
        locale: "de_de",
      },
      {
        id: "books-fitbook-brand",
        themeName: ThemeName.bild_fitbook,
        xHandle: "fitbook_de",
        locale: "de_de",
      },
      {
        id: "books-stylebook-brand",
        themeName: ThemeName.bild_stylebook,
        xHandle: "stylebook_de",
        locale: "de_de",
      },
      {
        id: "books-techbook-brand",
        themeName: ThemeName.bild_techbook,
        xHandle: "techbook",
        locale: "de_de",
      },
      {
        id: "books-myHomebook-brand",
        themeName: ThemeName.bild_myhomebook,
        xHandle: "myhomebook_de",
        locale: "de_de",
      },
      {
        id: "welt-brand",
        themeName: ThemeName.welt_brandstory,
        xHandle: "welt",
        locale: "de_de",
      },
      {
        id: "welt-product-advertorial",
        themeName: ThemeName.welt_productstory,
        xHandle: "welt",
        locale: "de_de",
      },
    ],
  },
  {
    id: "MEDIAPIONEER",
    themeName: ThemeName.mediapioneer,
    xHandle: "mediapioneercom",
    locale: "de_de",
  },
  {
    id: "MUSIKEXPRESS",
    themeName: ThemeName.musikexpress,
    xHandle: "musikexpressde",
    locale: "de_de",
  },
  {
    id: ORG_BILDTVAPP,
    themeName: ThemeName.bild,
    xHandle: "bild",
    locale: "de_de",
  },
  {
    id: "ROLLINGSTONE",
    themeName: ThemeName.rollingstone,
    xHandle: "rollingstoneDE",
    locale: "de_de",
  },
  {
    id: "METALHAMMER",
    themeName: ThemeName.metalhammer,
    xHandle: "metalhammer_de",
    locale: "de_de",
  },
  {
    id: "RINGIERAXELSPRINGER",
    themeName: ThemeName.default,
    locale: "pl_pl",
  },
  {
    id: "WELT_CONTRAST",
    themeName: ThemeName.welt_contrast,
    locale: "de_de",
  },
];

export const getBrand = (
  organizationId: string,
  categoryId?: string,
  locale?: string,
  themeName?: ThemeName
): BrandSettings => {
  const organization = organizations.find(
    (org) => org.id === organizationId.toUpperCase()
  );

  let brand = organization ?? DEFAULT_BRAND_SETTINGS;

  if (organization && categoryId) {
    const category = organization.categories?.find(
      (cat) => cat.id === categoryId.toLowerCase()
    );
    brand = category ?? organization;
  }

  // return with overwrites
  return {
    ...brand,
    ...(locale && { locale }),
    ...(themeName && { themeName }),
  };
};
